module.exports = __webpack_public_path__ + "img/slide3.6c73e4a9.png";